/* Maison Ronron v13 bis « ultime » — Installation, avis, FAQ (préfixe i), maquette validée le 14/10/2026.
   - Titres mot à mot, chapeaux, encarts : classe .i-on à l'entrée à l'écran.
   - Installation : trait qui se dessine au défilement (monotone), étapes qui s'allument (.i-allume) avec leurs dessins.
   - Avis (seulement s'il y a de vrais avis) : parallaxe des deux photos (--i-q).
   - FAQ : accordéon fluide, une seule question ouverte à la fois.
   Sans JavaScript tout reste visible (les états de départ n'existent que sous .i-vivant / .i-acc). */
(function () {
  'use strict';

  const groupes = new Set();
  let defilementPose = false;
  const borne = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

  function initialiser(groupe) {
    if (!groupe || groupe.dataset.iPret) return;
    groupe.dataset.iPret = '1';
    const MR14 = window.MR14 || {};
    const reduit = !!MR14.reduit || document.documentElement.classList.contains('reduit');
    const io = 'IntersectionObserver' in window;
    const cartes = [...groupe.querySelectorAll('.i-sec')];

    const etat = {
      groupe,
      etapes: groupe.querySelector('[data-i-etapes]'),
      lis: [...groupe.querySelectorAll('[data-i-etape]')],
      noeuds: [...groupe.querySelectorAll('[data-i-noeud]')],
      photos: groupe.querySelector('[data-i-photos]'),
      trace: 0,
      allumees: [false, false, false],
      anime: !reduit && io,
    };

    // ---------- Accordéon (toujours actif, même en mouvement réduit) ----------
    const liste = groupe.querySelector('[data-i-faq]');
    if (liste) {
      const boutons = [...liste.querySelectorAll('[data-i-q]')];
      const ouvrir = (btn, ouvert) => {
        const li = btn.closest('.i-q');
        if (li) li.classList.toggle('i-ouvert', ouvert);
        btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      };
      boutons.forEach((b) => ouvrir(b, false));
      liste.classList.add('i-acc');
      liste.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-i-q]');
        if (!btn || !liste.contains(btn)) return;
        const deja = btn.getAttribute('aria-expanded') === 'true';
        boutons.forEach((b) => ouvrir(b, false));
        if (!deja) ouvrir(btn, true);
      });
      // Éditeur de thème : sélectionner un bloc « question » l'ouvre
      groupe.addEventListener('shopify:block:select', (e) => {
        const btn = e.target.querySelector && e.target.querySelector('[data-i-q]');
        if (!btn) return;
        boutons.forEach((b) => ouvrir(b, false));
        ouvrir(btn, true);
      });
    }

    // ---------- Mouvement réduit / pas d'IntersectionObserver : tout visible, immobile ----------
    if (!etat.anime) return;

    cartes.forEach((c) => c.classList.add('i-vivant'));
    const cibles = [...groupe.querySelectorAll('[data-i-on]')];
    const voir = (el) => el.classList.add('i-on');
    if (typeof MR14.unefois === 'function') {
      MR14.unefois(cibles, voir, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    } else {
      const obs = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { obs.unobserve(e.target); voir(e.target); } }), { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      cibles.forEach((c) => obs.observe(c));
    }
    // Un élément qui reçoit le focus clavier est montré tout de suite
    groupe.addEventListener('focusin', (e) => { const c = e.target.closest && e.target.closest('[data-i-on]'); if (c) voir(c); });

    groupes.add(etat);
    if (!defilementPose) {
      defilementPose = true;
      if (typeof MR14.auDefilement === 'function') {
        MR14.auDefilement(cadre);
      } else {
        let raf = 0;
        const demande = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; cadre(); }); };
        addEventListener('scroll', demande, { passive: true });
        addEventListener('resize', demande, { passive: true });
        demande();
      }
    } else {
      cadre();
    }
  }

  function cadre() {
    const vh = window.innerHeight || 800;
    groupes.forEach((g) => {
      if (!g.groupe.isConnected) { groupes.delete(g); return; }

      // Trait d'installation (monotone : il ne se « dé-dessine » pas)
      const n0 = g.noeuds[0];
      const n2 = g.noeuds[g.noeuds.length - 1];
      if (g.etapes && n0 && n2 && g.trace < 1) {
        const r = g.etapes.getBoundingClientRect();
        if (r.top < vh * 1.1 && r.bottom > -vh) {
          const a = n0.getBoundingClientRect();
          const b = n2.getBoundingClientRect();
          const ecart = b.top - a.top;
          let p = ecart > 20
            ? (vh * 0.62 - (a.top + a.height / 2)) / ecart
            : (vh * 0.82 - r.top) / (vh * 0.42);
          p = borne(p);
          if (r.bottom < 0) p = 1;
          if (p > g.trace) {
            g.trace = p;
            g.etapes.style.setProperty('--i-trace', p.toFixed(4));
            g.etapes.style.setProperty('--i-s0', borne(p * 2).toFixed(4));
            g.etapes.style.setProperty('--i-s1', borne(p * 2 - 1).toFixed(4));
            const seuils = [0.001, 0.49, 0.985];
            g.lis.forEach((li, n) => {
              if (!g.allumees[n] && p >= seuils[n]) { g.allumees[n] = true; li.classList.add('i-allume'); }
            });
          }
        }
      }

      // Parallaxe des deux photos d'avis
      if (g.photos) {
        const r = g.photos.getBoundingClientRect();
        if (r.bottom > -200 && r.top < vh + 200) {
          const q = (r.top + r.height / 2 - vh / 2) / vh;
          g.photos.style.setProperty('--i-q', Math.max(-1.2, Math.min(1.2, q)).toFixed(4));
        }
      }
    });
  }

  const tout = () => document.querySelectorAll('.i-groupe').forEach(initialiser);
  const demarrer = (fn) => (window.MR14 && typeof window.MR14.pret === 'function')
    ? window.MR14.pret(fn)
    : (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  demarrer(tout);

  // Éditeur de thème : la section est re-rendue
  document.addEventListener('shopify:section:load', (e) => {
    const g = e.target.classList && e.target.classList.contains('i-groupe') ? e.target : e.target.querySelector && e.target.querySelector('.i-groupe');
    if (g) initialiser(g);
  });
})();
